<template>
  <transition name="fade">
    <div v-if="showMessage" id="flash-banner" :class="status">
      <div class="flash-message">{{ message }}</div>
      <span class="close" @click="closeFlash">Close</span>
    </div>
  </transition>
</template>

<script>
import { EventBus } from "@/eventbus";

export default {
  name: "FlashBanner",
  props: {
    message: {
      type: String
    },
    status: {
      type: String
    },
    duration: {
      type: Number
    }
  },
  computed: {
    showMessage() {
      return this.message && this.status;
    }
  },
  methods: {
    closeFlash() {
      EventBus.$emit("clearFlash");
    }
  }
};
</script>

<style lang="scss" scoped>
#flash-banner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  position: absolute;
  top: 2rem;
  left: 50%;
  z-index: 30;
  margin-right: -50%;
  transform: translate(-50%, -50%);

  padding: 0 1.5rem;
  min-height: 4rem;
  min-width: 400px;
  color: white;
}
.flash-message {
  flex-grow: 0;
  flex-shrink: 1;
}
.error {
  background-color: rgb(133, 68, 68);
} // .error
.success {
  background-color: rgb(64, 128, 64);
}
.close {
  text-transform: uppercase;
  cursor: pointer;
}
</style>
